import React from "react";
import { Icon } from "semantic-ui-react";
import styles from "./dragAndDropSection.module.scss";
import cn from "classnames";

interface DragAndDropSectionProps {
  hasMultipleFiles?: boolean;
}

const ICONS = {
  default: "fa-cloud-upload",
  error: "fa-exclamation-triangle",
};

const MESSAGES = {
  default: "Drop Files Here to Upload",
  error: "Only one file can be uploaded at a time",
};

const DragAndDropSection: React.FC<DragAndDropSectionProps> = ({ hasMultipleFiles }) => {
  const isError = !!hasMultipleFiles;

  return (
    <div className={cn(styles.dropSection, { [styles.error]: isError })}>
      <div className={styles.overlay} />
      <div className={cn(styles.dropBox)}>
        <div className={styles.content}>
          <Icon className={cn(isError ? ICONS.error : ICONS.default, "fa-lg", styles.icon)} aria-hidden="true" />
          <span>{isError ? MESSAGES.error : MESSAGES.default}</span>
        </div>
      </div>
    </div>
  );
};

export default DragAndDropSection;
